// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSharedGlobalIdModel {
    static getAttributeTypeMap() {
        return PrescriberSharedGlobalIdModel.attributeTypeMap;
    }
}
PrescriberSharedGlobalIdModel.discriminator = undefined;
PrescriberSharedGlobalIdModel.additionalProperties = false;
PrescriberSharedGlobalIdModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    },
];
//# sourceMappingURL=prescriberSharedGlobalIdModel.js.map